import * as Yup from 'yup';
import type { OptionTypeBase } from 'react-select';
import {
  reports_custom_group_filter,
  reports_default_group_filter,
  reports_gender_filter,
  reports_progression_filter,
  reports_quality_filter,
} from '../pages/types';

export const DATE_RANGE_SCHEMA = Yup.object().shape({
  startDate: Yup
    .date()
    .required(),
  endDate: Yup
    .date()
    .required(),
});

export const SET_TOPIC_FOCUS_SCHEMA = Yup.object().shape({
  topic: Yup
    .object()
    .shape({
      value: Yup.string(),
      label: Yup.string(),
    } as OptionTypeBase)
    .required(),
  set_students: Yup
    .array()
    .of(Yup.string())
    .min(1)
    .required(),
  startDate: Yup
    .date()
    .required(),
  endDate: Yup
    .number()
    .required(),
});

export const CANCEL_TOPIC_FOCUS_SCHEMA = Yup.object().shape({
  cancel_students: Yup
    .array()
    .of(Yup.string())
    .min(1)
    .required(),
});

export const STUDENTS_FILTER_SCHEMA = Yup.object().shape({
  student: Yup
    .array()
    .of(Yup.string())
    .min(1)
    .required(),
});

export const GROUP_FILTER_SCHEMA = Yup.object().shape({
  group: Yup
    .string()
    .oneOf([ ...reports_default_group_filter, ...reports_custom_group_filter ])
    .required(),
});

export const QUALITY_FILTER_SCHEMA = Yup.object().shape({
  quality: Yup
    .string()
    .oneOf(reports_quality_filter)
    .required(),
});

export const PROGRESSION_FILTER_SCHEMA = Yup.object().shape({
  progression: Yup
    .string()
    .oneOf(reports_progression_filter)
    .required(),
});

export const GENDER_FILTER_SCHEMA = Yup.object().shape({
  gender: Yup
    .string()
    .oneOf(reports_gender_filter)
    .required(),
});

export const TAG_FILTER_SCHEMA = Yup.object().shape({
  tag: Yup
    .string()
    .required(),
});

export const HANDLE_DOWNLOAD_SCHEMA = Yup.object().shape({
  students: Yup
    .array()
    .of(Yup.string())
    .min(1)
    .required(),
  settings: Yup
    .array()
    .of(Yup.string()),
});

export const MANAGE_METRICS_SCHEMA = Yup.object().shape({
  default_settings: Yup
    .array()
    .ensure()
    .of(Yup.string())
    .when('additional_settings', {
      is: (value: Yup.ArraySchema<Yup.StringSchema<string | undefined>>) => !value?.length,
      then: Yup.array().min(1),
    }),
  additional_settings: Yup
    .array()
    .ensure()
    .of(Yup.string())
    .when('default_settings', {
      is: (value: Yup.ArraySchema<Yup.StringSchema<string | undefined>>) => !value?.length,
      then: Yup.array().min(1),
    }),
}, [ [ 'additional_settings', 'default_settings' ] ]);

export const PARENT_MAILING_SCHEMA = Yup.object().shape({
  parents: Yup
    .array()
    .of(Yup.object({
      name: Yup.string().required('Name cannot be empty.').min(1),
      email: Yup.string().email('Invalid mail.').required('Mail required.'),
    }))
    .required(),
});
